import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import TabsList from "./TabsList";
import {
  buildEventsManagementPath,
  EVENT_MGMT_ROUTE_PERMISSIONS,
} from "../shared/utils/eventManagementTabs";

export const EVENT_TAB_DASHBOARD = "dashboard";
export const EVENT_TAB_CALENDAR = "calendar";
export const EVENT_TAB_MANAGEMENT = "management";
export const EVENT_TAB_CHECKIN = "checkin";

/**
 * Cross-route tabs between Event Dashboard, Event Calendar, Event Management, and Event Check-In.
 */
export default function EventSectionTabs({ activeTab }) {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const showDashboard = hasPermission && hasPermission("menu.event_dashboard");
  const showCalendar = hasPermission && hasPermission("menu.event_calendar");
  const showManagement =
    hasPermission &&
    EVENT_MGMT_ROUTE_PERMISSIONS.some((permissionId) => hasPermission(permissionId));
  const showCheckIn = hasPermission && hasPermission("menu.event_qr_checkin");

  return (
    <TabsList className="section-tabs-list" role="tablist" aria-label="Event sections">
      {showDashboard ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === EVENT_TAB_DASHBOARD}
          className={`tab-btn ${activeTab === EVENT_TAB_DASHBOARD ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== EVENT_TAB_DASHBOARD) navigate("/EventDashboard");
          }}
        >
          Event Dashboard
        </button>
      ) : null}
      {showCalendar ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === EVENT_TAB_CALENDAR}
          className={`tab-btn ${activeTab === EVENT_TAB_CALENDAR ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== EVENT_TAB_CALENDAR) navigate("/EventCalendar");
          }}
        >
          Event Calendar
        </button>
      ) : null}
      {showManagement ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === EVENT_TAB_MANAGEMENT}
          className={`tab-btn ${activeTab === EVENT_TAB_MANAGEMENT ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== EVENT_TAB_MANAGEMENT) navigate(buildEventsManagementPath());
          }}
        >
          Event Management
        </button>
      ) : null}
      {showCheckIn ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === EVENT_TAB_CHECKIN}
          className={`tab-btn ${activeTab === EVENT_TAB_CHECKIN ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== EVENT_TAB_CHECKIN) navigate("/EventQRCheckIn");
          }}
        >
          Event Check-In
        </button>
      ) : null}
    </TabsList>
  );
}
